import { Routes, Route, Navigate } from "react-router-dom";
import * as React from "react";
// import Dashboard from "../Pages/Dashboard";
import PrivateRoute from "./PrivateRoute";
import AuthRoute from "./AuthRoute";
import Navigation from "./navigation/navigation.component";
import Products from "./products/products.component";
import Services from "./services/services.component";
import Login from "./login/login.component";
import BookingNavigation from "./bookings/bookings-navigation.component";
import Sales from "./sales/sales.component";
import AdminRoutes from "./admin/admin.route";
import AdminProtected from "./AdminProtected.route";
import Subscription from "./subscription/subscription.component";
import BusinessInfoForm from "../components/business-info/business-info-form";
import ReportNavigation from "./report/report-navigation.component";
import BusinessRegisteration from "../components/business-registration/business-registeration.component";
import QRProtectedRoute from "./QrProtectedRoute";
import QRCodeGenerator from "../components/qr-generator/qr-generator.component";

function RoutePage() {
  return (
    <Routes>
      <Route path="/login" element={<AuthRoute element={Login} />} />
      <Route
        path="/external-business-registration/:token"
        element={<QRProtectedRoute element={BusinessRegisteration} />}
      />
      {/* Redirect users trying to access without token */}
      <Route 
        path="/external-business-registration" 
        element={<Navigate to="/services" replace />} 
      />
      <Route path="/" element={<PrivateRoute element={Navigation} />}>
        <Route index element={<Services />} />
        <Route path="products/*" element={<Products />} />
        <Route path="services/*" element={<Services />} />
        <Route path="bookings/*" element={<BookingNavigation />} />
        <Route path="sales/*" element={<Sales />} />
        <Route path="businessInfo" element={<BusinessInfoForm />} />
        <Route path="report/*" element={<ReportNavigation />} />
        <Route
          path="admin/*"
          element={<AdminProtected element={AdminRoutes} />}
        />
        <Route path="subscription/*" element={<Subscription />} />
        <Route path="qr-generator" element={<QRCodeGenerator />} />
      </Route>
      {/* FOR NOW, if user is entering wrong URL, redirecting them to our home page i.e services temporary */}
      <Route path="*" element={<Navigate to="/services" />} />
    </Routes>
  );
}

export default RoutePage;
